import { ErrorMessage, Field, Form, Formik } from "formik";
import * as Yup from "yup";

import { Helmet } from "react-helmet";
import { RequestorService } from "../../Services/Requestor.Service";
import TokenService from "../../Services/Token.service";
import Loader from "../../Components/Loader";
import { useEffect, useState } from "react";
import Toaster from "../../Components/Toaster";
import ParentStudies from "../Admin/SampleRequests/ParentStudies";

function ParentStudiesHome() {
    const initialValues = {
        parentStudyName: ''
    }
    const validationSchema = Yup.object().shape({
        parentStudyName :  Yup.string()   
        .min(2, "Parent study name must be at least 2 characters long")
        .max(255, "Parent study name cannot exceed 255 characters")
        .required("Please enter a parent study name"),
    })

    const [loading, setLoading] = useState(false);
    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [editingStudy, setEditingStudy] = useState(null);


    useEffect(()=>{
    },[editingStudy])
    const handleSubmit = async (values, { resetForm, setSubmitting }) => {
        const isEdit = editingStudy !== null; 
        const payload = {
            user_id: TokenService.getUserId(), 
            title : values.parentStudyName,
            ...(isEdit && editingStudy?.id && { study_id: editingStudy.id })
        }
        try{    
            setLoading(true);
               const result = isEdit
            ? await RequestorService.updateParentStudy(payload)
            : await RequestorService.addParentStudy(payload);

            
            if(result.success ){
                setToastMessage(result.message);
                setShowToast(true)
                setToastVariant(result.success ? 'success': 'error');
                if(!isEdit){
                    resetForm();
                }
                setRefreshTrigger(prev => prev + 1);
                setEditingStudy(null);
            }
            else {
                setToastMessage(result.message);
                setShowToast(true)
                setToastVariant(result.status ? 'success': 'error')
            }

        }catch(e){console.log(e)}
        finally{setLoading(false);}
        console.log("Form submitted:", values);
    };
    return (<>
        <Helmet>
            <title>DonorX | Parent Studies</title>
        </Helmet>
         <Loader loading={loading} />
        <div className="el-middle-wrapper">
            <div className="el-bg-table">
                {/* style={{ width: "45%" }} */}
                <div className="d-flex justify-content-between align-items-center" style={{ marginRight: '15px' }}>
                    <p>Parent studies are used for larger single collections and long-term studies. It enables you to easily exclude donors that have already donated samples or easily include them in a repeat study.</p>
                </div>
                <div>
                    <p>For example:</p>
                    <ul>
                        <li>You have a large project that will require multiple collection days and don’t want the same donor more than once.</li>
                        <li>You are duplicating a request and want to include or recall prior donors.</li>
                    </ul>
                </div>
                <div>
                    <Formik enableReinitialize  
                        initialValues={{
                            parentStudyName: editingStudy?.title || ''
                        }} 
                        validationSchema={validationSchema} 
                        onSubmit={handleSubmit}> 
                        {({isSubmitting  })=>
                            (
                                <Form>
                                    <div className="mb-3 parent-study">
                                        <Field
                                        type="text"
                                        name="parentStudyName"
                                        className="form-control"
                                        placeholder="New Parent Study"
                                        maxLength = {255}
                                        />
                                        <ErrorMessage
                                        name="parentStudyName"
                                        component="div"
                                        className="text-danger mt-1"
                                        />
                                    </div>

                                    <button
                                        type="submit"
                                        className="el-main-button me-3"
                                        disabled={isSubmitting}
                                    >
                                         <span>{editingStudy ? 'Update Parent Study' : 'Save Parent Study'}</span>
                                    </button>
                                </Form>
                            )
                        }
                    </Formik>
                </div>
            </div>
        </div>
        <div className="el-middle-wrapper">
            <div className="el-middle-section"> 
                {/* <div className="el-middle-top"> */}
                    <ParentStudies setEditingStudy={setEditingStudy} refreshTrigger={refreshTrigger}></ParentStudies>
                {/* </div> */}
            </div>
        </div>
        <Toaster
            show={showToast}
            message={toastMessage}
            variant={toastVariant}
            onClose={() => setShowToast(false)}
        />
    </>);
}
export default ParentStudiesHome;